import { frontendURL } from '../../../helper/URLHelper';
import DashboardAnalytics from './DashboardAnalytics.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/dashboard-analytics'),
      name: 'dashboard_analytics',
      component: DashboardAnalytics,
      // Los asesores tambien: el dashboard les muestra su propio tablero acotado.
      meta: { permissions: ['administrator', 'agent'] },
    },
  ],
};
